/**
 * Mulberry32 — a small, fast, deterministic PRNG.
 *
 * Every schematic on the site is generated from a fixed seed so the shapes are
 * identical for every visitor and across server render and hydration. A shape
 * that changed between the two would be a hydration mismatch.
 */
export function seeded(seed: number): () => number {
  let s = seed | 0;
  return () => {
    s = (s + 0x6d2b79f5) | 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
